module.exports = __webpack_public_path__ + "img/thumb-instyle-fragrances@2x.6a5767f9.png";